function _URL() {};
_URL.createQueryStringFromObject = function(obj) {
    const sp = new URLSearchParams('');
    Object.entries(obj).map(entry => {
      sp.append(entry[0], entry[1]);
    });
    return sp;
}

export default _URL;